export default {
  order_methods: {
    delivery: 'Consegna',
    pickup: 'Ritiro',
    room_service: 'Sul posto',
    table_service: 'Sul posto',
  },
  time: '{{time}} min',
  asap: 'Subito',
  unavailable: 'Non disponibile',
  ready_in: 'Pronto in ',
  buttons: {
    change: 'Cambia',
    see_hours: 'Vedi orari',
    change_location: 'Cambia posizione',
    change_time: 'Cambia orario',
  },
};
